import { UserInfoFI } from "@/components/HolderForm/UserInfoFI.ts";
import { UserInfoFormValues } from "@/components/HolderForm/UserInfoFormValues.ts";
import { WarningToast } from "@/components/Notifications/WarningToast.tsx";
import { ReservationOfferCarrier } from "@/helpers/types/types.ts";
import toast from "react-hot-toast";

const defaultCountry = "HRV";

const isValidIso3Code = (value?: string | null): boolean => {
  return !!value && /^[A-Z]{3}$/.test(value);
};

const getValidCountryIso = (countryIso?: string | null, isCompany = false): string => {
  if (!countryIso) return "";
  if (isValidIso3Code(countryIso)) return countryIso;

  toast.custom(
    <WarningToast message={`Failed to update ${isCompany ? "company country" : "country"}, wrong format`} />,
  );
  return defaultCountry;
};

export const transformCarrierPayloadToFormData = (carrier: ReservationOfferCarrier): UserInfoFormValues => {
  const isCompany =
    !!carrier?.companyAddress ||
    !!carrier?.companyName ||
    !!carrier?.companyVatId ||
    !!carrier?.companyCountryIso;

  return {
    [UserInfoFI.FirstName]: carrier.firstName || "",
    [UserInfoFI.LastName]: carrier.lastName || "",
    [UserInfoFI.Country]: getValidCountryIso(carrier.countryIso),
    [UserInfoFI.Address]: carrier.address || "",
    [UserInfoFI.PostalCode]: carrier.postalCode || "",
    [UserInfoFI.City]: carrier.city || "",
    [UserInfoFI.Email]: carrier.email || "",
    [UserInfoFI.Phone]: carrier.phoneNumber || "",
    [UserInfoFI.Note]: "",
    [UserInfoFI.IsCompany]: isCompany,
    [UserInfoFI.CompanyName]: carrier.companyName || "",
    [UserInfoFI.CompanyAddress]: carrier.companyAddress || "",
    [UserInfoFI.CompanyVAT]: carrier.companyVatId || "",
    [UserInfoFI.CompanyCountry]: getValidCountryIso(carrier.companyCountryIso, true),
  };
};
